import React from 'react';
import { FormContext } from '../FormContext';

export default function UneditableInput() {
	const formContext = React.useContext(FormContext);
	const { rowOptions, formValuesById } = formContext;
	const { rowTypeData } = rowOptions;

	return <span>{formValuesById[rowTypeData.inputId]}</span>;
}
